import React, { useEffect, useState } from "react";
import {
  DeleteRivalAds,
  GetRivalAdsAll,
} from "../../../../../../../../core/Services";
import { BsFillTrashFill } from "react-icons/bs";
import { Dialog } from "primereact/dialog";
import { Button } from "@chakra-ui/react";
import { useToast } from "@chakra-ui/react";
import { Paginator } from "primereact/paginator";

export default function Editing({ uniqueCustomerId, months, tableKey }) {
  const [viewVisitor, setViewVisitor] = useState([]);
  const [selectedViewVisitor, setSelectedViewVisitor] = useState(null);
  const [displayConfirmation, setDisplayConfirmation] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(5);
  const toast = useToast();

  useEffect(() => {
    GetRivalAdsAll(uniqueCustomerId)
      .then((data) => {
        setViewVisitor(data.data);
      })
      .catch((error) => {
        console.log("Ülke Veri Çekme Hatası", error);
      });
  }, [uniqueCustomerId, deleteSuccess, tableKey]);

  useEffect(() => {
    if (deleteSuccess) {
      toast({
        title: "Başarılı",
        description: "Veri başarıyla silindi.",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
      setDeleteSuccess(false);
    }
  }, [deleteSuccess, toast]);

  const handleDelete = (viewVisitorId) => {
    setSelectedViewVisitor(viewVisitorId);
    setDisplayConfirmation(true);
  };

  const onDeleteConfirmation = () => {
    DeleteRivalAds(selectedViewVisitor);
    setDeleteSuccess(true);
    setSelectedViewVisitor("");
    setDisplayConfirmation(false);
  };

  const onHide = () => {
    setDisplayConfirmation(false);
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  return (
    <div className="w-full">
      <div className="mb-3 font-bold w-full">Düzenleme & Gösterim :</div>
      <table
        className="w-full"
        style={{
          fontFamily: "arial, sans-serif",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            ></th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Dönem
            </th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Url
            </th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Gösterim Payı (%)
            </th>
          </tr>
        </thead>
        <tbody>
          {viewVisitor &&
            viewVisitor?.slice(first, first + rows)?.map((visitor, index) => (
              <tr
                key={visitor.id}
                style={{
                  border: "1px solid #dddddd",
                  textAlign: "left",
                  padding: "8px",
                }}
              >
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {index + 1 + first}
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {months?.find((month) => month.value === visitor.month)?.name}
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {" "}
                  {visitor.url}
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {visitor.show}
                </td>

                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  <button
                    className="ml-2"
                    onClick={() => handleDelete(visitor.id)}
                  >
                    <BsFillTrashFill />
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      <Paginator
        first={first}
        rows={rows}
        totalRecords={viewVisitor?.length}
        onPageChange={onPageChange}
      />
      <Dialog
        visible={displayConfirmation}
        style={{ width: "450px" }}
        onHide={onHide}
        position="center"
        header="İçerik Düzenleme"
      >
        <p>Veriyi silmek istediğinize emin misiniz?</p>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "1rem",
            marginTop: "1rem",
          }}
        >
          <Button colorScheme="red" onClick={onHide}>
            Hayır
          </Button>
          <Button colorScheme="green" onClick={onDeleteConfirmation}>
            Evet
          </Button>
        </div>
      </Dialog>
    </div>
  );
}
